import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = (companyId) => ['account_for_receivables', companyId];

const getCheckUploadByHoustingStock = async (companyId) => {
  return await request.get(
    `/Receivable/account_for_receivables?companyId=${companyId}`,
    null,
    'При проверке признака возможности загрузки должников по ЛС из ЖФ произошла ошибка'
  );
};

const useCheckUploadByHoustingStock = (companyId, options) =>
  useQuery(
    key(companyId),
    () => getCheckUploadByHoustingStock(companyId),
    options
  );

export default useCheckUploadByHoustingStock;
